
        import * as module0 from './controllers/openable_controller.js'
        const modules = {
            "./controllers/openable_controller.js": module0,
        };
        export default modules;
      